import React, { DetailedHTMLProps } from 'react'

export default function CardHeader({ children, className, ...props }: DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) {
    return <div className={'card-header' + (className ? ` ${className}` : '')} {...props}>{children}</div>
}
